// extracted by mini-css-extract-plugin
export var lbContainerOuter = "w_tn";
export var lbContainerInner = "w_tp";
export var movingForwards = "w_tq";
export var movingForwardsOther = "w_tr";
export var movingBackwards = "w_ts";
export var movingBackwardsOther = "w_tt";
export var lbImage = "w_tv";
export var lbOtherImage = "w_tw";
export var prevButton = "w_tx";
export var nextButton = "w_ty";
export var closing = "w_tz";
export var appear = "w_tB";